import { render, staticRenderFns } from "./CustomerStatement.vue?vue&type=template&id=0033d984&scoped=true"
import script from "./CustomerStatement.vue?vue&type=script&lang=js"
export * from "./CustomerStatement.vue?vue&type=script&lang=js"
import style0 from "./CustomerStatement.vue?vue&type=style&index=0&id=0033d984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0033d984",
  null
  
)

export default component.exports